import script from "./DialogBoxSight.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogBoxSight.vue?vue&type=script&setup=true&lang=ts"

import "./DialogBoxSight.vue?vue&type=style&index=0&id=4110399a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4110399a"]])

export default __exports__